import React, { ReactNode } from 'react'
import Footer from './Footer'
import Header from './Header'
import Chatbot from './Chatbot'

type PageLayoutProps = {
  children: ReactNode
  lang    : string
  pageDesc?: string
  pageKws?: string
  pageTitle?: string
  ogUrl?: string
  switchLang: any
  inclChatbot?: boolean
}

export default function PageLayout({ children, lang, switchLang, inclChatbot = true, pageTitle, pageDesc, pageKws, ogUrl }: PageLayoutProps) {
  return (
    <div className='bg-white relative w-full h-full bg-cover overflow-x-hidden'
      style={{ height: 'auto' }}
    >
      <Header lang={lang} switchLang={switchLang} pageTitle={pageTitle} pageDesc={pageDesc} pageKws={pageKws} ogUrl={ogUrl} />
      { children }
      <Footer lang={lang} />
      {inclChatbot ? (
        <div className='fixed bottom-6 right-1'>
          <Chatbot />
        </div>
      ) : <></>}
    </div>
  )
}
